import './testimonials.scss'
import TestimonialsSwiperCarousel from './testimonials.swiper.carousel'
import { Link } from 'react-router-dom'
import i18n from '../../i18n'
import React from 'react'
import testimonialsData from './testimonials.data'

export default function Testimonials(props) {
    const { language } = props
    const { testimonialsTextSeller, testimonialsTextBuyer } = testimonialsData

    const testimonialsTexts = [...testimonialsTextSeller, ...testimonialsTextBuyer];
    return (
        <section className="testimonials-section">
            <div className="testimonials-section-content py-5">
                <div className="container mt-5">
                    <div className="section-title text-center testimonial-custom-title">
                        <h6>{i18n.t('homepage.testimonials.header-text')}</h6>
                        <h2>{i18n.t('homepage.testimonials.title')}</h2>
                    </div>

                    <div className="carousel">
                        <TestimonialsSwiperCarousel customClassName={"py-3"} data={testimonialsTexts} effect={'coverflow'} slidesPerView={'auto'} autoplay={true} initialSlide={Math.floor(testimonialsTexts.length / 2)} />
                    </div>
                    <div
                        className="d-flex justify-content-center"
                        style={{ marginTop: '40px' }}
                    >
                        <Link
                            to="/testimonios"
                            type="button"
                            className="fix-button-link btn btn-primary rounded-pill start-button g-action-button"
                        >
                            {i18n.t('homepage.testimonials.more')}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
